import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Route, Routes } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: "https://d81678ff89ec8b5c53c46d214f6254ef@o4506262642032640.ingest.sentry.io/4506287720431616",
  release: process.env.REACT_APP_SENTRY_RELEASE,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

declare global {
  interface Window {
    regenerateQrcode: any;
    setConfig: any;
    GENIUS_PROJECTION_ID: string;
    GENIUS_SECRET: string;
    GENIUS_INDIRECTION_ID: string;
    GENIUS_BOT: string;
  }
}

const theme = extendTheme({
  styles: {
    global: {
      'html, body': {
        background: 'none',
        height: '1900px',
        width: '2200px',
        overflow: 'hidden',
      },
    },
  },
});

type TConfig = {
  bot: string;
  secret: string;
  indirectionId: string;
};

window.setConfig = async (config: TConfig) => {
  window.GENIUS_SECRET = config.secret;
  window.GENIUS_INDIRECTION_ID = config.indirectionId;
  window.GENIUS_BOT = config.bot;
  let data: any;

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <ChakraProvider theme={theme}>
          <Routes>
            <Route path="/:cubeId" element={<App />} />
          </Routes>
        </ChakraProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: 
// https://bit.ly/CRA-vitals
reportWebVitals();
window.setConfig({
  bot: 'mona',
  secret: 'password',
  indirectionId: 'd7ebcacf-0d32-4d7b-bfe8-9f75739073e1'
});
